// Build-time Firebase config selector.
//
// Set REACT_APP_KARMUH_ENV=dev to use dev credentials (karmuh-dev project).
// Default (unset or "prod") uses the karmuh prod project.
//
// Both configs are checked into the repo — they're public values
// (Firebase API keys are designed to be public, per Firebase docs).

import FirebaseConfigDev from './FirebaseConfigDev';

const FirebaseConfigProd = {
  apiKey: 'AIzaSyA6lArnUdqSrEgXdeZL_u8BbZCueVw4D_4',
  authDomain: 'karmuh.firebaseapp.com',
  projectId: 'karmuh',
  measurementId: 'G-8M26F0LK12',
};

const env = process.env.REACT_APP_KARMUH_ENV || 'prod';
const FirebaseConfig = env === 'dev' ? FirebaseConfigDev : FirebaseConfigProd;

export default FirebaseConfig;
